import { render, staticRenderFns } from "./AmountCard.vue?vue&type=template&id=1465664c"
import script from "./AmountCard.vue?vue&type=script&lang=js"
export * from "./AmountCard.vue?vue&type=script&lang=js"
import style0 from "./AmountCard.vue?vue&type=style&index=0&id=1465664c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports